<template>
  <div class="chat-wrapper" :class="{
    'chat-wrapper-safearea': safearea && isRoomList,
  }">
    <!-- 未登录  -->
    <!-- (autoRegisterLoading && !sdkRoomId) 如果sdkRoomId为空, 则显示未登录页面，避免展示空状态 -->
    <div class="not-login-chat-wrapper" v-if="!isLogin || (autoRegisterLoading && !sdkRoomId)">
      <PcNotLoginBox v-if="isPc && (pcMode || goodsDetailMode)">
        <template #header>
          <div class="room-header-custom">
            <div class="left">
              <div @click="goBack" class="back" v-if="!inAppTab && !pcMode && !goodsDetailMode">
                <img src="@/assets/svg-icons/back.svg" />
              </div>
            </div>
            <div class="center">
              <div class="blank"></div>
              <div class="title">
                <p>Zoomies</p>
                <span>7*24 hours</span>
              </div>
              <div class="loading-wrapper">
                <van-loading v-show="autoRegisterLoading" type="spinner" size="20px" />
              </div>
            </div>
            <div class="right">
              <div class="lang-switch" @click="wsLangPopShow = true">
                <img src="@/assets/images/im/lang.png" />
                <span v-if="wsLocaleLang">{{ wsLocaleLang.name }}</span>
              </div>
            </div>
          </div>
        </template>

      </PcNotLoginBox>
      <div v-else class="flex flex-col  h-100% bg-#f8f8f8">
        <div class="room-header-custom-new" v-if="!isRoomList && inAppEnv" >
          <div class="left">
            <div @click="goBack" class="back">
              <img src="@/assets/svg-icons/back.svg" />
            </div>
          </div>
          <div class="center">
            <div class="title">
              <p>Zoomies</p>
            </div>
          </div>
          <div class="right" />
        </div>
        <div class="flex flex-col items-center  px-50 pt-80">
          <van-image :width="115" :height="105" :src="zommiesIcon">
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
          <p class="text-#666 text-center m-0 mb-11 py-6 leading-15">
            {{ $t(`message.sentence1`) }}
          </p>
          <van-button @click="handleLogin" :loading="autoRegisterLoading" loading-type="spinner" class="h-36 !text-#333 text-14 rounded-6 login-loading-btn" block color="#F3B847">
            {{$t("message.login") }}
          </van-button>
        </div>
      </div>
    </div>
    <!-- <van-button @click="doTest">测试清空rooms</van-button> -->
    <vue-advanced-chat v-if="isLogin" platform="customer" :pcMode="isPc" :height="'100%'" class="chat-room"
      :single-room="!isRoomList" :show-search="false" :show-add-room="false" :show-files="true" :show-menu="showMenu"
      :show-audio="false" :room-href="true" :current-user-id="imUserData.imUserIdStr" :room-id="sdkRoomId"
      :rooms="JSON.stringify(allRooms)" :loading-rooms="sdkLoadingRooms" :rooms-loaded="chatsLoaded"
      :messages-loaded="messagesLoaded" :messages="JSON.stringify(newMessages)" :accepted-files="'image/*,video/*'"
      :rooms-list-opened="roomsListOpended" :network-exception="isDisconnect" @open-file="openFile($event.detail[0])"
      @open-failed-message="openFailedMessage($event.detail[0])" @send-message="sendMessageBefore($event.detail[0])"
      @send-message-reaction="sendMessageReaction($event.detail[0])" @fetch-messages="fetchMessages($event.detail[0])"
      @fetch-more-rooms="fetchMoreRooms" @send-custom-card="sendCustomCard($event, $event.detail[0])"
      @toggle-room-chat="toggleRoomChat($event.detail[0])" @trigger-custom-card="triggerCard($event, $event.detail[0])"
      @message-custom-view="messageCustomView($event.detail[0])" @open-user-tag="onOpenUserTag($event.detail[0])"
      @room-select="fetchMessagesPathHref($event.detail[0])">
      <div slot="room-header" class="room-header-custom">
        <div class="left">
          <div @click="goBack" class="back" v-if="!inAppTab && !pcMode">
            <img src="@/assets/svg-icons/back.svg" />
          </div>
        </div>
        <div class="center">
          <div class="blank"></div>
          <div class="title">
            <p>Zoomies</p>
            <span>7*24 hours</span>
          </div>
          <div class="loading-wrapper">
            <van-loading v-show="finalLoading" type="spinner" size="20px" />
          </div>
        </div>
        <div class="right">
          <div class="lang-switch" @click="wsLangPopShow = true">
            <img src="@/assets/images/im/lang.png" />
            <span v-if="wsLocaleLang">{{ wsLocaleLang.name }}</span>
          </div>
        </div>
      </div>
      <div slot="send-menu-list" class="send-menu-list">
        <!-- 这里写菜单列表 -->
        <div v-for="menu in menuList" class="send-menu-item" :key="menu.name">
          <div class="image" @click="doSelectMenu($event, menu)">
            <van-image :src="menu.src" />
          </div>
          <span>{{ menu.name }}</span>
        </div>
      </div>
      <div slot="network-exception">
        <NetwordException v-if="isDisconnect" type="roomlist" :is-room-list="isRoomList" @reconnect="errorReconnect" />
      </div>
      <div slot="network-exception-room" class="network-exception-room">
        <NetwordException v-if="isDisconnect" type="room" @reconnect="errorReconnect" />
      </div>
      <div class="speak-warn-msg" :slot="'message_' + warnMsgId">
        <div class="head">
          <img src="@/assets/images/common/logo.png" />
          <span>{{ $t("message.warnSpeakTitle") }}</span>
        </div>
        <div class="body">
          <div class="content">
            {{ $t("message.warnSpeakP1") }}<br />
            {{ $t("message.warnSpeakP2") }}
          </div>
        </div>
      </div>
      <div v-for="_msg in newMessages.filter(i=>i.newSystemType||(i.messageType==='SYSTEM_NOTIFICATIONS_EVALUATION_INVITATION')&&i.cardEvaluationInvitation)" :key="_msg._id"  :slot="'message_' + _msg._id">
        <Review v-if="_msg.messageType==='SYSTEM_NOTIFICATIONS_EVALUATION_INVITATION'" :reviewMessage="_msg" class="new-system-msg" />
        <div class="new-system-msg" v-else-if="_msg.newSystemType">
          <div class="head">
            <img src="@/assets/images/common/logo.png" />
            <span>{{ $t("message.warnSpeakTitle") }}</span>
          </div>
          <div class="body">
            <div class="content">
              {{ _msg.content }}
            </div>
          </div>
        </div>
      </div>

      <div class="tab-select-msg" :slot="'message_' + tabMsgId">
        <template v-if="tabMsg && tabMsg?.tabInfo">
          <div class="title">
            {{ tabMsg?.tabInfo.subTitle }}
          </div>
          <ul class="tabs">
            <li v-for="item in tabMsg?.tabInfo.tabContents" @click="handleTabClick(item)">
              {{ item.content }}
            </li>
          </ul>
          <div class="sub-title">
            {{ tabMsg?.tabInfo.title }}
          </div>
        </template>
      </div>
      <div class="join-msg" :slot="'message_' + (lastJoinMsg?._id || 0)">
        <template v-if="lastJoinMsg">
          <img :src="getImageUrlLimitSize(lastJoinMsg.headImage, avatarSize)" />
          <div class="name">
            {{ lastJoinMsg.username }}
          </div>
          <div class="desc">
            {{ $t("message.serverDesc") }}
          </div>
        </template>
      </div>
      <div class="wait-msg" v-if="waitMsgId" :slot="'message_' + waitMsgId">
        <img :src="dogHead" />
        <div class="name">
          {{ $t("message.serverWaitTip") }}
        </div>
        <div class="desc">
          {{ $t("message.serverWaitDesc") }}
        </div>
      </div>
      <div slot="message_notlogin">www</div>
    </vue-advanced-chat>

    <WsLangPop v-model:show="wsLangPopShow" @closePop="wsLangPopShow = false" />
    <ReviewPop :visible.sync="reviewShow" :review-message="reviewMessage" @toggle-view="reviewShow = false" />
    <ConSultDialog v-model:tab="menuType" v-model:show="menuVisible" @send="sendMenuCard"
      :showTip="isSendQueueWhenCloseDialog" />
    <!-- <ReconnectDialog v-if="!isRoomList" v-model:show="reconnectDialogVisible" @reconnect="errorReconnect" /> -->
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  onMounted,
  computed,
  onBeforeUnmount,
  onActivated,
  nextTick,
} from "vue";
import { storeToRefs } from "pinia";
import { showToast } from "vant";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { register } from "@voghion/vue-advanced-chat/external";
// import {register} from "../../../dist/vue-advanced-chat.es";
import { useSetting } from "@/composables/use-setting";
import { useMsgStore } from "@/states/msg";
import { useUserStore } from "@/states/user";
import { useNotifyStore } from "@/states/notify";
import { useNewinStore } from "@/states/newin";
import { useRouterAdv } from "@/composables/use-router-adv";
import {
  navigateTo,
  openCustomerServiceChat,
  jsBridge,
  EVENT_VENDOR_CALLBACK,
} from "@voghion/native-api";
import { urlToBlobWithMimeType, isIOS } from "@/utils/tool";
import {
  getResource,
  isSingleRoom,
  getCustomServiceRoom,
  filterRoom,
} from "@/utils/msgFilter";
import WsLangPop from "./WsLangPop/index.vue";
import ReviewPop from "./ReviewPop/ReviewPop.vue";
import Review from "./ReviewPop/Review.vue";
// import ReconnectDialog from "./ReconnectDialog/ReconnectDialog.vue";
import ConSultDialog from "@/components/consult-dialog/index.vue";
import NetwordException from "./NetworkException/NetworkException.vue";
import favoriteIcon from "@/assets/images/im/menu_favorite.png";
import ordersIcon from "@/assets/images/im/menu_orders.png";
import viewIcon from "@/assets/images/im/menu_commodity.png";
import cartIcon from "@/assets/images/im/menu_cart.png";
import zommiesIcon from "@/assets/images/im/zommies.png";
import VipIcon from "@/assets/images/im/vip.png";
import menu_camera from "@/assets/images/im/menu_camera.png";
import dogHead from "@/assets/images/im/dogHead.png";
// import menu_pic from "@/assets/images/im/menu_pic.svg";
import { safeWatch } from "@/composables/use-vue-adv";
import { useEnvStore } from "@/states/env";
import { wsLangSetting } from "@/composables/use-ws-lang";
import { Env } from "@voghion/fe-util";
import { formatLocalTime, convertUTCTimeToLocal } from "@/utils/time";
import { MessageListUpdateMode } from "@/utils/constant";
import PcNotLoginBox from "./PcNotLoginBox/notLoginChatBox.vue";
import { CLIENT_CHANNEL } from "@/constants";
import { getImageUrlLimitSize } from "@voghion/fe-util";

register();

const avatarSize = window.devicePixelRatio * 45

const env = Env.getInstance();

const envStore = useEnvStore();
const { inAppTab } = storeToRefs(envStore);

const route = useRoute();
const { pageFrom, platform } = getResource();
const inAppEnv = computed(() => {
  return env.isEnvAppWebView;
});

const props = defineProps({
  // 页面 top 模块的高度
  pageTopHeight: {
    type: Number,
    default: 0,
  },
  // 页面顶部banner模块
  pagePaddingTop: {
    type: Number,
    default: 0,
  },
  pageError: {
    type: String,
    default: "",
  },
  /**
   * 指定房间号，如不不指定，显示会话列表
   */
  roomId: {
    type: Number,
    default: 0,
    required: false,
  },
  /**
   * socket连接参数
   */
  connectParams: {
    type: Object,
    default() {
      return {};
    },
  },
  /**
   * 是否处理安全区域
   */
  safearea: {
    type: Boolean,
    default: false,
  },
  autoRegisterLoading: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits<{
  /**
   * 是否已就绪，用于埋点
   */
  ready: [conversationId: number];
}>();

const { t } = useI18n();
const { getClientInfo } = useSetting();
const userStore = useUserStore();
const notifyStore = useNotifyStore();
const newinStore = useNewinStore();

const checkLogin = userStore.checkLogin;
const isLogin = computed(() => userStore.isLogin);
const routerAdv = useRouterAdv();
const clientInfo = getClientInfo();
const reviewShow = ref(false);
const reviewMessage = ref({});
const menuVisible = ref(false);
const showOutService = ref(true);
const isSendQueueWhenCloseDialog = ref(false);
const isRoomList = computed(() => {
  return !props.roomId && !isSingleRoom();
});
const wsLangPopShow = ref(false);
const wsSetting = wsLangSetting();
wsSetting.init();
const { wsLocaleLang, updateLanguagestorageKey } = wsSetting;

const goBack = () => {
  routerAdv.back();
};

const roomsListOpended = ref(isRoomList.value);

// type defaultChatType = {
//   roomName?: string;
//   avatar?: string;
//   roomId?: number;
//   [key: string]: any;
// };
// const defaultChat: Ref<defaultChatType> = ref({users: []});

const showMenu = computed(() => pageFrom !== "payment");

const isPc = computed(() => Number(clientInfo.channel) === CLIENT_CHANNEL.PC)
// pcMode只代表页面来源是pcHome的场景
const pcMode = computed(() => pageFrom === "pcHome");
const goodsDetailMode = computed(() => pageFrom === "goodsDetail");

const msgStore = useMsgStore();
const {
  rooms,
  messages: currentMessages,
  imUserData,
  sdkLoadingRooms,
  chatsLoaded,
  messagesLoaded,
  messagesAll,
  roomChatOpen,
  wsIsError,
  wsLoading,
  warnMsgId,
  wsStatus,
  socketReady,
  tabMsgId,
  waitMsgId,
  selectedConversationId,
} = storeToRefs(msgStore);

/**
 * 当前的房间ID
 */
const finalRoomId = computed(() => {
  return props.roomId ? props.roomId : selectedConversationId.value;
});

/**
 * 当前的房间
 */
const currentFetchRoom = computed(() => {
  return rooms.value.find((r) => r.roomId === finalRoomId.value);
});

/**
 * 传给 sdk 的 roomId，在请求到房间列表数据后再设置，避免 sdk 报错
 */
const sdkRoomId = computed(() => {
  return !isRoomList.value && currentFetchRoom.value ? finalRoomId.value : "";
});

const messages = computed(() => {
  return props.roomId
    ? messagesAll.value[props.roomId] || []
    : currentMessages.value;
});

const isDisconnect = computed(() => {
  return wsStatus.value !== "open" && msgStore.showNetworkException;
});

const loading = ref(false);
const finalLoading = computed(() => {
  return wsLoading.value || loading.value;
});

const menuList = ref([
  { name: t("message.Camera"), src: menu_camera, type: "camera" },
  { name: t("message.Order"), src: ordersIcon, type: "order" },
  { name: t("message.viewed"), src: viewIcon, type: "viewed" },
  { name: t("message.favorites"), src: favoriteIcon, type: "favorites" },
  { name: t("message.cart"), src: cartIcon, type: "cart" },
]);
const menuType = ref("");

// tab选项卡相关
const tabMsg: any = computed(() => {
  if (messages.value && messages.value.length > 0) {
    return messages.value.find((obj) => obj._id === tabMsgId.value);
  }
  return null;
});

const newMessages: any = computed(() => {
  const newMsgs = [...messages.value];
  if (newMsgs && newMsgs.length > 0) {
    const joins = messages.value.filter((obj) => obj.join);

    if (joins.length > 0) {
      joins[joins.length - 1].system = false;
      joins[joins.length - 1].custom = true;
    }
  }
  return newMsgs;
});

const lastJoinMsg: any = computed(() => {
  if (newMessages.value && newMessages.value.length > 0) {
    const joins = newMessages.value.filter((obj) => obj.join);

    if (joins.length > 0) {
      return joins[joins.length - 1];
    } else {
      null;
    }
  }
  return null;
});

const handleTabClick = (tab) => {
  msgStore.doSendQueueMsg({ tab });
};

// 外部客服房间
const customServiceRoom = getCustomServiceRoom(imUserData);

const allRooms = computed(() => {
  let arr = [];

  const roomsArr = Array.from(rooms.value) || [];
  const rmList = roomsArr;
  // defaultRooms.value?.map((i) => {
  //   const o = roomsArr.find((m) => m.categoryExperts === i.categoryExperts);
  //   return o || i;
  // }) || [];
  // roomsArr && roomsArr.length > 0 ? roomsArr : [defaultChat.value];

  if (!isRoomList.value) {
    arr = roomsArr;
    const roomId = props.roomId || selectedConversationId.value
    if (roomId) {
      arr = arr.filter((r) => String(r.roomId) === String(roomId));
      if (!roomsArr.length) {
        // todo 没有匹配房间时，暂时选第一个
        arr = roomsArr.filter((_, n) => n === 0);
      }
    }
  } else {
    if (showOutService.value) {
      // 有内部，无外部
      arr = rmList;
    } else {
      // 有外部，内部看情况
      arr = [customServiceRoom, ...rmList];
    }
  }
  let newArr = arr.map((e) => ({
    ...e,
    roomId: e.roomId + "",
    lastMessage: {
      ...e.lastMessage,
      timestamp: `${e?.lastMessage?.date || ""} ${e?.lastMessage?.timestamp || ""
        }`,
    },
  }));

  if (platform !== "PC") {
    newArr = [
      ...newArr,
      {
        avatar:
          "https://g-images.voghion.com/productImages/245_1725444144499_voghion92x92.png",
        hasOrder: true,
        lastMessage: notifyStore.notify?.messageBoxNotifyVo?.content
          ? {
            content: notifyStore.notify.messageBoxNotifyVo?.content,
            timestamp: formatLocalTime(
              "DD/MM/YYYY HH:mm",
              convertUTCTimeToLocal(notifyStore.notify.messageBoxNotifyVo?.pushTime)
            ),
            date: formatLocalTime(
              "DD/MM/YYYY",
              convertUTCTimeToLocal(notifyStore.notify.messageBoxNotifyVo?.pushTime)
            ),
            username: "",
          }
          : null,
        robot: true,
        roomId: -1,
        roomName: t('message.ServiceNotification'),
        // sessionId: 1722,
        // sessionOpen: false,
        // toCombineId: 8,
        // toUserRole: "GROUP_KEY_ACCOUNT_MANAGER_SALES_BEFORE",
        toUserType: "GROUP",
        unreadCount: notifyStore.notify?.messageBoxNotifyVo?.unreadNum || 0,
        // isRedDot: true,
        users: [],
        navigateTo: "/service-notification",
      },
    ];

    if (notifyStore.notifyVip?.messageBoxNotifyVo?.content) {
      newArr = [
        ...newArr,
        {
          avatar: VipIcon,
          hasOrder: true,
          lastMessage: notifyStore.notifyVip?.messageBoxNotifyVo?.content
            ? {
              content: notifyStore.notifyVip.messageBoxNotifyVo?.content,
              timestamp: formatLocalTime(
                "DD/MM/YYYY HH:mm",
                convertUTCTimeToLocal(notifyStore.notifyVip.messageBoxNotifyVo?.pushTime)
              ),
              date: formatLocalTime(
                "DD/MM/YYYY",
                convertUTCTimeToLocal(notifyStore.notifyVip.messageBoxNotifyVo?.pushTime)
              ),
              username: "",
            }
            : {},
          robot: true,
          roomId: -1,
          roomName: t("VipNotification"),
          toUserType: "GROUP",
          unreadCount: notifyStore.notifyVip?.messageBoxNotifyVo?.unreadNum || 0,
          // isRedDot: true,
          users: [],
          navigateTo: "/vip-notification",
        },
      ];
    }
  }
  return newArr;
});

const handleLogin = async () => {
  await checkLogin({ showPcLogin: true });

  newinStore.getMarketing();
};

let scrollTimer: NodeJS.Timeout | undefined;

const roomScrollBottom = () => {
  scrollTimer = setTimeout(() => {
    const chatElement = document.querySelector("vue-advanced-chat");
    const shadowRoot = chatElement.shadowRoot;
    const element = shadowRoot.querySelector("#messages-list");
    if (element) {
      element.classList.add("vac-scroll-smooth");
      element.scrollTo({ top: element.scrollHeight, behavior: "smooth" });
      setTimeout(() => element.classList.remove("vac-scroll-smooth"));
    }
  }, 500);
};

const enterRoomBeforeGetList = async (room) => {
  await doConnect();
  // 进入房间前创建会话
  const {
    toUserRole,
    toUserType,
    roomId,
    sessionId,
    sessionOpen,
    robot,
    categoryExperts,
  } = room;

  if (
    !isRoomList.value &&
    wsStatus.value === "open" &&
    (!roomId || !sessionId || !sessionOpen || robot)
  ) {
    const res: any = await msgStore.doCreateRoom({
      toUserRole,
      toUserType,
      conversationId: roomId,
      categoryExperts,
    });
    if (res) {
      if (!roomId) {
        room.roomId = res.conversationId;
        room.sessionId = res.sessionId;
      }
    }
    return (
      res || {
        isNewSession: false,
      }
    );
  }
  return {
    isNewSession: false,
  };
};

const enterRoomAfterGetList = async (room) => {
  const { pageFrom }: { pageFrom?: string } = getResource();
  // 是否展示卡片
  if (["goodsDetail", "orderDetail", "orderList", "refundDetail", "afterSaleServicePage"].includes(pageFrom)) {
    // 进入页面后会自动拉取历史对话列表，如果是第一次拉取对话列表，还会根据条件判断是否展示发送卡片
    msgStore.doLocalSendCard(room);
  }
  roomScrollBottom();
};

// const initMenuModal = (pageFrom, room) => {
//   // 是否弹出tab
//   if (
//     ["orderDetailRightSideTopIcon", "orderListRightsideTopIcon"].includes(
//       pageFrom
//     )
//   ) {
//     // 进入页面后，弹出menu的tab
//     menuVisible.value = true;
//     menuType.value = "order";
//   }
//   if (["me"].includes(pageFrom) || !pageFrom) {
//     menuVisible.value = true;
//     if (room.hasOrder) {
//       menuType.value = "order";
//     } else {
//       menuType.value = "viewed";
//     }
//   }
// };

const isFirstPageMsgGet = ref(false);

const fetchMessagesPathHref = async ({ room }) => {
  if (room.navigateTo) {
    if (room.navigateTo === "/service-notification") {
      notifyStore.clearUnread(false);
    }
    if (room.navigateTo === "/vip-notification") {
      notifyStore.clearUnread(true);
    }
    routerAdv.navigateTo({ path: room.navigateTo });
  } else {
    // 如果重新进入页面，创建会话
    const { toCombineId, toUserRole, toUserType, roomId, categoryExperts } = room;
    if (platform === "PC") {
      jsBridge.callPromise({ noResponse: true }, EVENT_VENDOR_CALLBACK, {
        key: "chatroom",
        toUserRole,
        toUserType,
        roomId,
        categoryExperts,
      });
    } else if (room.isCustom) {
      if (Number(room.roomId) < 0) {
          console.log('fetchMessagesPathHref', room);
        const createRes: any = await msgStore.doCreateRoom({
          toUserRole,
          toUserType,
          conversationId: roomId,
          categoryExperts,
        });
        console.log(createRes);
        const firstRoomInfo = {
          categoryExperts,
          conversationId: createRes.conversationId,
          hasOrder: false,
          headImage: room.avatar,
          latestContent: "",
          latestContentTranslate: "",
          latestTime: "",
          latestTimestamp: 0,
          nickname: room.roomName,
          online: false,
          processingStatus: "PROCESSING",
          sessionId: createRes.sessionId,
          sessionOpen: true,
          toCombineId,
          toUserRole,
          toUserType,
          unreadCount: 0,
          voghionUserId: null,
        };
        const [firstRoom] = filterRoom([firstRoomInfo], imUserData);
        // defaultChat.value = firstRoom;
        setTimeout(() => {
          fetchMessagesPathHref({ room: firstRoom });
          msgStore.getChatList({
            page: 1,
            forceRefresh: true,
          });
        }, 50);
      } else if (room.roomId === 0) {
        openCustomerServiceChat({ extInfo: {} });
      }
    } else {
      const chatQueryObj = {
        pageFrom: "imConversationList",
        toCombineId: room.toCombineId,
        toUserRole: room.toUserRole,
        toUserType: room.toUserType,
        categoryExperts: room.categoryExperts,
      };
      routerAdv.navigateTo({
        path: `/chatroom/${room.roomId}`,
        query: chatQueryObj,
      });
    }
  }
};

const currentRoom = ref(null);
const currentRoomOptions = ref<{
  reset?: Boolean;
  refresh?: Boolean;
}>({
  reset: false,
  refresh: false,
});
const roomDataReady = ref(false);

const innerFetchMessages = async (room) => {
  const options = currentRoomOptions.value;
  // const room = currentRoom.value;

  if (loading.value) return;

  let beforeComplete: any = false;
  let res = {};
  loading.value = true;
  try {
    if (options.reset) {
      // 进入聊天框，加载历史消息前执行的方法
      beforeComplete = await enterRoomBeforeGetList(room);
      isFirstPageMsgGet.value = !!beforeComplete.isNewSession;
    } else {
      beforeComplete = true;
    }
    const updateMode = options.refresh
      ? MessageListUpdateMode.Refresh
      : options.reset
        ? MessageListUpdateMode.Reset
        : MessageListUpdateMode.LoadMore;
    res = await msgStore.getMessageList(
      room,
      updateMode,
      isFirstPageMsgGet.value
    );
    if (res) {
      roomDataReady.value = true;
    }
  } catch (err) {
    console.log(err);
  }
  loading.value = false;
  if (options.reset) {
    // 加载聊天信息后，执行的方法
    await enterRoomAfterGetList(room);
    if (
      beforeComplete &&
      typeof beforeComplete === "object" &&
      beforeComplete.isNewSession
    ) {
      // initMenuModal(pageFrom, room);
    }
    if (currentRoom.value) {
      if (pcMode.value) {
        checkCatchMessage(currentRoom.value?.roomId)
      } else if (goodsDetailMode.value) {
        setTimeout(() => {
          checkCatchMessage(currentRoom.value?.roomId)
        }, 2000)
      }
    }
    checkUserTranslateLanguage()
  }
  return res;
};

safeWatch(socketReady, (val) => {
  if (val) {
    if (currentRoom.value && !roomDataReady.value) {
      innerFetchMessages(currentRoom.value);
    }
  } else {
    loading.value = false;
    roomDataReady.value = false;
    currentRoomOptions.value = {
      reset: true,
      refresh: true,
    };
  }
});

/**
 * im 库进入房间会触发该回调
 * @param param0
 */
const fetchMessages = async ({ options, room }) => {
  const newRoom = rooms.value.find((i) => i.roomId === Number(room.roomId));
  if (newRoom) {
    msgStore.clearRoomUnreadCount(newRoom);
    currentRoom.value = newRoom;
    roomDataReady.value = false;
    currentRoomOptions.value = options || {
      reset: false,
      refresh: false,
    };
    if (socketReady.value) {
      // 如果已经建立连接了
      innerFetchMessages(room);
    } else {
      // 尝试建立连接
      doConnect();
    }
  }
};

// robot阶段，首次发送消息后，展开弹窗，如果关闭则发送45
safeWatch(menuVisible, (val) => {
  if (!val && isSendQueueWhenCloseDialog.value) {
    isSendQueueWhenCloseDialog.value = false;
    // 如果用户是主动发送了视频或图片，并且还未发送完成，单独再发送一条文本消息，避免客服进线后看不到有效信息
    msgStore.doSendQueueMsg({});
  }
});

const isRobotFirstSendMsg = () => {
  const room = msgStore.getSelecteRoom();

  if (room.robot) {
    if (pcMode.value) {
      msgStore.doSendQueueMsg({});
    } else {
      isSendQueueWhenCloseDialog.value = true;
      menuVisible.value = true;
      menuType.value = "order";
    }
  }
};

const convertSdkMessage = (message) => {
  message.roomId = parseInt(message.roomId);
};

// --------------------- //
const sendMessageBefore = (message) => {
  convertSdkMessage(message);
  if (message.files && message.files.length > 0) {
    sendMessage(message);
  }

  if (message.content) {
    sendMessage({ ...message, files: null });
  }
};
const sendMessage = (messageData) => {
  const { files } = messageData;
  const msgType = files && files.length > 0 ? "file" : "text";
  if (msgType === "file") {
    files.forEach(async (file) => {
      const msg = { ...messageData, msgType, files: [file] };
      msgStore.doSendMessage(msg);
    });
  } else {
    msgStore.doSendMessage({ ...messageData, msgType });
  }

  isRobotFirstSendMsg();
};

/**
 * 表情回复
 * @param e
 */
const sendMessageReaction = (message) => {
  convertSdkMessage(message);
  msgStore.doSendMessageReaction(message);
};

const fetchMoreRooms = async () => {
  msgStore.getChatList({
    page: msgStore.chatPageIndex + 1,
  });
};

const sendCustomCard = (e, { message }) => {
  e.preventDefault();
  e.stopPropagation();
  convertSdkMessage(message);
  msgStore.doSendMessage({ ...message, msgType: "card" });
  sendQueneByCard(message.card.type);

};

// 发送菜单里的卡片
const sendMenuCard = ({ data, type }) => {
  msgStore.sendMenuCard(data, type);
  sendQueneByCard(type);
  menuVisible.value = false;
};

// 发送卡片排队信息
const sendQueneByCard = (type) => {
  let from = "";
  if (type === "order") {
    from = "chatBoxOrder";
  } else {
    from = "chatBoxGoods";
  }
  msgStore.doSendQueueMsg({ from });
};

const triggerCard = ($event, { message }) => {
  const { messageType } = message.card
  if (messageType === 'CARD_GOODS_GUIDE_BOOK') {
    openFile({ file: { file: { url: message.card?.url } } })
  } else if(messageType === 'CARD_USER_POINTS_INFO'){
    if (inAppEnv.value) {
      navigateTo({ url: message.card?.customerSchema });
    }
  } else {
    const type = message.card.type;
    let schemeUrl = null;
    if (type === "goods") {
      schemeUrl = message.card?.cardGoods?.customerSchema;
    } else if (type === "order") {
      schemeUrl = message.card?.cardOrder?.customerSchema;
    }
    navigateTo({ url: schemeUrl });
  }
};

const errorReconnect = () => {
  msgStore.doReconnect();
};

const openFailedMessage = async ({ message }) => {
  convertSdkMessage(message);
  if (message.files && message.files.length > 0) {
    let file = message.files[0];
    /**
     * 由于传给 sdk 的消息没有 blob，所以需要重新通过 url 还原 blob
     * 部分手机（三星）上，url 还原 blob 时可能出错，加个 try catch
     * 发送内部会自动适配
     */
    try {
      const { blob, mimeType } = await urlToBlobWithMimeType(file.preview);
      file = {
        ...file,
        type: mimeType,
        localUrl: file.preview,
        blob,
      };
    } catch (err) {
      console.log('无法通过 url 还原 blob', err)
    }
    msgStore.doSendFailureAgain({ ...message, files: [file] });
  } else {
    msgStore.doSendFailureAgain(message);
  }
};

const toggleRoomChat = ({ opened }) => {
  roomChatOpen.value = opened;
  msgStore.clearWarnMsgById();
};

const openFile = ({ file }) => {
  if (!env.isEnvAppWebView) {
    window.open(file.file.url);
    return;
  }
  if (isIOS()) {
    navigateTo({ url: file.file.url });
  } else {
    if (clientInfo.appVersion >= "2.0.6") {
      routerAdv.navigateToWebView(`${file.file.url}`, { external: 1 });
    } else {
      showToast({ message: t("message.versionTooLow") });
    }
  }
};

const messageCustomView = ({ messageId, roomId }) => {
  roomId = parseInt(roomId);
  const message = messages.value.find(
    (r) => String(r._id) === String(messageId)
  );
  if (
    message &&
    !message.seen &&
    message.senderId !== String(imUserData.value.imUserId)
  ) {
    msgStore.viewMessages([message._id], roomId);
  }
};

const doClearAllChat = () => {
  msgStore.doViewAllChat();
};

const onOpenUserTag = ({ user, message }) => {
  if (reviewShow.value === true) return;
  if (user.user._id === "clickReview") {
    reviewShow.value = true;
    reviewMessage.value = message;
  }
};

const doSelectMenu = (e, menu) => {
  e.preventDefault();
  e.stopPropagation();

  if (menu.type === "camera") {
    const vac = document.querySelector("vue-advanced-chat");
    if (vac) {
      const footerFile: any = vac.shadowRoot.querySelector("#footerFile");
      footerFile.click();
    }
    return;
  }

  menuType.value = menu.type;
  menuVisible.value = !menuVisible.value;
};

const doConnect = () => {
  // 建立连接
  return msgStore.doConnect(props.connectParams);
};

const dataInit = async () => {
  if (isRoomList.value) {
    // 判断是否展示外部客服
    const res = await msgStore.getDiversionIm({});
    showOutService.value = res.data;
  }

  // await initRooms();

  // const defaultChatRes = await msgStore.getDefaultChat();
  // const {toCombineId, toUserRole, toUserType, iconUrl} = defaultChatRes;
  // defaultChat.value = {
  //   roomId: -1,
  //   roomName: "VIP Service",
  //   avatar: iconUrl,
  //   unreadCount: 0,
  //   toCombineId,
  //   toUserRole,
  //   toUserType,
  //   users: [{}],
  //   lastMessage: {content: ""},
  //   isCustom: true,
  // };
};

const checkCatchMessage = (roomId: number) => {
  // 检查并发送缓存消息
  const hasCacheMessage = msgStore.catchMessage.content || msgStore.catchMessage.files.length > 0
  if (roomId && userStore.shouldCheckMessage && hasCacheMessage) {
    const cMessage = msgStore.catchMessage
    const message = {
      content: cMessage.content,
      replyMessage: cMessage.replyMessage,
      files: [...cMessage.files],
      roomId: roomId
    }
    sendMessageBefore(message)
    userStore.shouldCheckMessage = false
    msgStore.clearCatchMessage()
  }
}

// 检查是否在未登录的状态下修改语言
const checkUserTranslateLanguage = () => {
  const updateLanguagestorage = localStorage.getItem(updateLanguagestorageKey)
  if (updateLanguagestorage && wsLocaleLang.value) {
    msgStore.modifyWsLang(wsLocaleLang.value?.short)
    localStorage.removeItem(updateLanguagestorageKey)
  }
}

const refreshData = () => {
  doConnect().then(
    () => {
      emits(
        "ready",
        currentRoom.value ? parseInt(currentRoom.value.roomId) : 0
      );
    },
    () => { }
  );
  dataInit();
};


safeWatch(
  () => {
    return userStore.userToken;
  },
  (val, oldValue) => {
    msgStore.closeRoom();
    if (val && !oldValue) {
      // 登录
      refreshData();
    }
  }
);

safeWatch(
  () => {
    return envStore.appVisible;
  },
  (val: boolean) => {
    if (!val) {
      msgStore.doDisconnect();
    } else {
      msgStore.initWorker();
      doConnect();
    }
  }
);

const messageListScrollHandler = () => {
  if (scrollTimer) {
    clearTimeout(scrollTimer);
    scrollTimer = undefined;
  }
};

onMounted(() => {
  const translateObj = {
    orderIdTxt: t("message.orderId"),
    orderTimeTxt: t("message.orderTime"),
    sendTxt: t("message.send"),
  };
  msgStore.staticInfo = translateObj;

  // 页面可见的时候尝试重连，解决打开新的长连接页面之前的连接被强制断开的问题
  document.addEventListener("visibilitychange", function () {
    const show = document.visibilityState === "visible";
    msgStore.togglePageVisible({ page: route.name, show });
  });
});

onActivated(() => {
  try {
    window.parent.postMessage("imInit", "*");
  } catch (error) {
    console.log(error);
  }

  if (userStore.isLogin) {
    refreshData();
  }

  nextTick(() => {
    const vac = document.querySelector("vue-advanced-chat");
    if (vac) {
      const messageList = vac.shadowRoot.querySelector("#messages-list");
      messageList &&
        messageList.addEventListener("scroll", messageListScrollHandler);
    }
  });

  selectedConversationId.value = finalRoomId.value;
});

onBeforeUnmount(() => {
  const vac = document.querySelector("vue-advanced-chat");
  if (vac) {
    const messageList = vac.shadowRoot.querySelector("#messages-list");
    messageList &&
      messageList.removeEventListener("scroll", messageListScrollHandler);
  }
});

defineExpose({ doClearAllChat });
</script>

<style scoped lang="scss">
.chat-wrapper {
  height: 100%;

  box-sizing: border-box;
  background-color: #f8f9fa;
  position: relative;

  &.chat-wrapper-safearea {
    padding-bottom: calc(constant(safe-area-inset-top) * 2 / 3);
    padding-bottom: calc(env(safe-area-inset-top) * 2 / 3);
  }

  .not-login-chat-wrapper {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    background-color: #fff;
  }
}

.chatroom-in {
  margin: 0;
}

.send-menu-list {
  display: flex;
  padding: 10px 10px;
  background-color: #f6f6f6;
  justify-content: flex-start;
  flex-wrap: wrap;

  .send-menu-item {
    text-align: center;
    width: 25%;
    box-sizing: border-box;
    margin-bottom: 14px;

    >span {
      font-size: 13px;
      color: #666666;
    }

    .image {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 64px;
      height: 64px;
      padding: 10px;
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 8px;
      margin: 0 auto 6px;
    }
  }
}

.network-exception {
  color: rgb(255, 73, 38);
  background-color: rgb(255, 234, 229);
  padding: 8px 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  border-radius: 3px;
  font-size: 12px;

  .warn-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    background-color: rgb(255, 73, 38);
    color: #fff;
    border-radius: 50%;
    margin: 0 6px;
  }

  .reconnect-btn {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 3px;
    padding-left: 10px;
    padding-right: 10px;
  }
}

.network-exception-room {
  position: sticky;
  top: 0;
  z-index: 9;
}

.speak-warn-msg,
.new-system-msg {
  background-color: #fff;
  margin: 10px;
  border-radius: 8px;
  padding: 16px;

  .head {
    display: flex;
    align-items: center;
    margin-bottom: 9px;

    img {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }

    span {
      font-weight: 500;
      font-size: 14px;
      color: #333333;
    }
  }

  .body {
    .content {
      font-size: 12px;
      color: #333333;
      line-height: 17px;
      font-weight: 400;
    }
  }
}

.tab-select-msg {
  background: #ffffff;
  margin: 10px;
  border-radius: 8px;
  padding: 16px 9px;
  max-width: 310px;

  .title {
    font-weight: 500;
    font-size: 14px;
    color: #694728;
    margin-bottom: 12px;
  }

  .sub-title {
    font-size: 14px;
    color: #333;
  }

  .tabs {
    list-style-type: disc;
    list-style-position: inside;

    li {
      border-radius: 2px;
      border: 1px solid #f6f6f6;
      padding: 10px 18px;
      margin-bottom: 6px;
      font-size: 12px;
      color: #333333;
    }
  }
}

.join-msg,
.wait-msg {
  position: relative;
  background: #ffffff;
  margin: 10px;
  margin-top: 40px;
  border-radius: 8px;
  padding: 8px;
  padding-top: 22px;

  img {
    position: absolute;
    left: calc(50% - 25px);
    top: -30px;
    width: 45px;
    height: 45px;
    border: 4px solid #f8f9fa;
    border-radius: 50%;
  }

  .name {
    font-size: 14px;
    color: #000000;
    line-height: 16px;
    margin-bottom: 4px;
    text-align: center;
  }

  .desc {
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    line-height: 15px;
    text-align: center;
  }
}

.room-header-custom,
.room-header-custom-new {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;

  .left,
  .right {
    width: 50px;
  }

  .back {
    padding-left: 10px;
    @include min-click();
  }

  .right {
    display: flex;
    justify-content: flex-end;
  }

  .center {
    display: flex;
    align-items: center;

    .blank {
      width: 28px;
    }

    .loading-wrapper {
      width: 20px;
      margin-left: 8px;
    }

    .title {
      text-align: center;

      p {
        margin: 0;
        font-weight: 600;
        font-size: 16px;
        color: #333333;
        line-height: 22px;
      }

      span {
        font-size: 10px;
        color: #999990;
        line-height: 11px;
      }
    }
  }

  .lang-switch {
    @include min-click();
    display: flex;
    align-items: center;
    padding-right: 10px;

    font-size: 12px;
    color: #333333;

    img {
      width: 26px;
      height: 26px;
    }
  }
}
.room-header-custom-new {
  height: 50px;
  background-color: #fff;
  border-bottom: 1px solid #e1e4e8;
  .back {
    padding-top: 4px;
    padding-left: 14px;
  }
}
</style>
<style lang="scss">
.login-loading-btn.van-button--loading {
  background-color: #BBBBBB !important;
  border-color: #BBBBBB !important;
}
</style>
